import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import ServiceForm from "@/components/services/service-form";

export const Route = createFileRoute("/_authenticated/services/_layout/new")({
  component: NewServicePage,
});

function NewServicePage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "services", actions: ["create"] }]}
    >
      <ServiceForm />
    </RouteGuardPermissions>
  );
}
